<div class="wrapper d-flex flex-column gap-3 h-100">
	<mat-card appearance="outlined" class="position-relative pe-4 h-100" [class]="{ canceled: isCanceled }">
		<button
			mat-icon-button
			class="position-absolute top-0 end-0 fs-5 mt-2 offerMenuButton"
			[matMenuTriggerFor]="menu"
		>
			<i class="fas fa-ellipsis-vertical"></i>
		</button>
		<mat-menu #menu="matMenu">
			<button
				[disabled]="isCanceled || service.isReservationCancelled"
				(click)="openChangeOfferDialog()"
				mat-menu-item
			>
				<span>Zmień ofertę konfigurator</span>
			</button>
			<button
				mat-menu-item
				class="changeOfferButton"
				[disabled]="isCanceled || service.isReservationCancelled"
				(click)="showChangeOfferListDialog(OfferChangeTypes.CHANGE)"
			>
				<span>Zmień ofertę lista</span>
			</button>
			<button
				[disabled]="isCanceled || service.isReservationCancelled"
				(click)="setOfferIdToChange()"
				mat-menu-item
			>
				<span>Wklej ofertę ze schowka</span>
			</button>
			<button
				[disabled]="service.isReservationCancelled"
				(click)="showChangeOfferListDialog(OfferChangeTypes.ADD)"
				mat-menu-item
			>
				<span>Dodaj pokój</span>
			</button>
			<!--			<button class="mat-menu-item">-->
			<!--				<span>Łącz turnus</span>-->
			<!--			</button>-->
			<button
				mat-menu-item
				class="cancelOfferButton"
				(click)="showCancelDialog()"
				[disabled]="isCanceled || service.isReservationCancelled || !isCancellable"
			>
				<span>Anuluj ofertę</span>
			</button>
		</mat-menu>
		<mat-card-title class="pe-2">
			<ng-container *ngIf="auth.permissionsByCode()[Permissions.ADMIN]">{{ offer?.id }}</ng-container>
			{{ offer?.status }} {{ offer?.product?.name }}
		</mat-card-title>
		<p>
			<ng-container *ngIf="roomType === null">Express</ng-container>
			<ng-container *ngIf="roomType"> {{ roomType?.code }} {{ roomType?.name }} </ng-container>
		</p>
		<mat-card-subtitle>
			{{ term?.dateRange.lower | dateBounds: term?.dateRange.bounds : true }}
			{{ term?.dateRange.upper | dateBounds: term?.dateRange.bounds : false }}
			{{
				dateService.daysBetween(
					term?.dateRange.lower | dateBounds: term?.dateRange.bounds : true,
					term?.dateRange.upper | dateBounds: term?.dateRange.bounds : false
				)
			}}d/{{ offer?.term?.nightsStay }}n
		</mat-card-subtitle>
		<mat-card-content class="d-flex flex-column gap-2">
			<span>{{ board?.code }} {{ board?.name }}</span>
			<span *ngIf="offer">
				Cena:
				<span class="mt-0 fw-bold">
					{{ offer.totalPrice - offer.additionalRoomSizeCharge | price }}
					PLN
				</span>
				<ng-container *ngIf="offer.additionalRoomSizeCharge">
					| Dopłata:
					<span class="mt-0 fw-bold">{{ offer.additionalRoomSizeCharge | price }} PLN</span>
				</ng-container>
			</span>
		</mat-card-content>
	</mat-card>
</div>
